import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=444a797a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=444a797a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a797a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('444a797a')) {
      api.createRecord('444a797a', component.options)
    } else {
      api.reload('444a797a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=444a797a&scoped=true&", function () {
      api.rerender('444a797a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v3U4B2qSjxGw/JS/comp/DocBox.vue"
export default component.exports